import React from 'react'
import { BsMailbox2, BsBellFill, BsSearch } from "react-icons/bs";

// CSS
import "../style/search.css"

// Image
import admin_pic from "../assets/admin_pic.png"
export default function Search() {
  return (
    <div className='Search'>
        <div className='search-left'>
            <div className='search-title'>Dashboard</div>
            <form>
            <input type="text" placeholder='Search'></input>
            <button><BsSearch /></button>
            </form>
        </div>

        <div className='buttons-grid'>
            <button><BsMailbox2 /></button>
            <button><BsBellFill /></button>
            <div className='admin-prof'>
                <img src={admin_pic} alt='Admin Pic'/>
            </div>
        </div>
    </div>
  )
}
